import React, { Component } from 'react';
import { Link } from "react-router-dom";
import NslMailAPI from '../NslMailAPI.js';

class ResetPassword extends Component {
    state = {
        message: "",
        isProcessing: true,
        success: false
    };

    async componentDidMount() {
        this.API = new NslMailAPI(null);
        
        // Get the auth_id from URL parameters
        const authId = this.props.match.params.auth_id;
        
        if (!authId) {
            this.setState({ 
                message: "Invalid reset link - no authentication token found.",
                isProcessing: false 
            });
            return;
        }

        try {
            let result = await this.API.resetPassword(authId);
            this.setState({ 
                message: result.message,
                isProcessing: false,
                success: true
            });
        } catch (error) {
            this.setState({ 
                message: error.message,
                isProcessing: false,
                success: false
            });
        }
    }

    render() {
        return (
            <div style={{
                maxWidth: "600px", 
                margin: "40px auto", 
                padding: "40px",
                backgroundColor: "white",
                border: "1px solid #89AACD",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
            }}>
                <div style={{textAlign: "center", marginBottom: "30px"}}>
                    <h1 style={{
                        fontSize: "24px", 
                        color: "#294081",
                        margin: "0 0 10px 0"
                    }}>
                        Password Reset
                    </h1>
                    <div style={{
                        height: "2px",
                        backgroundColor: "#89AACD",
                        width: "60px",
                        margin: "0 auto"
                    }}></div>
                </div>

                {this.state.isProcessing ? (
                    <div style={{textAlign: "center", padding: "40px 20px"}}>
                        <div style={{marginBottom: "20px"}}>
                            <img src="/images/indicator_big.gif" alt="loading" style={{width: "32px", height: "32px"}} />
                        </div>
                        <p style={{fontSize: "16px", color: "#666", margin: "0"}}>
                            Processing your password reset request...
                        </p>
                    </div>
                ) : (
                    <div style={{textAlign: "center"}}>
                        <div style={{
                            marginBottom: "30px", 
                            padding: "20px", 
                            backgroundColor: this.state.success ? "#e8f5e8" : "#ffebee", 
                            border: `1px solid ${this.state.success ? "#4caf50" : "#f44336"}`, 
                            borderRadius: "6px",
                            color: this.state.success ? "#2e7d32" : "#c62828"
                        }}>
                            <div style={{fontSize: "18px", marginBottom: "8px"}}>
                                <strong>
                                    {this.state.success ? "✓ Password Reset Successful!" : "✗ Password Reset Failed"}
                                </strong>
                            </div>
                            <div style={{fontSize: "14px"}}>
                                {this.state.message}
                            </div>
                        </div>
                        
                        {this.state.success ? (
                            <div>
                                <div style={{
                                    marginBottom: "30px", 
                                    padding: "20px", 
                                    backgroundColor: "#f8f9fa", 
                                    border: "1px solid #e9ecef", 
                                    borderRadius: "6px",
                                    textAlign: "left",
                                    lineHeight: "1.6em"
                                }}>
                                    <p style={{margin: "0 0 15px 0", fontWeight: "bold", color: "#294081"}}>What happens next:</p>
                                    <p style={{margin: "0 0 10px 0"}}>• Check your email for your new temporary password</p>
                                    <p style={{margin: "0 0 10px 0"}}>• Use the new password to log into your account</p>
                                    <p style={{margin: "0"}}>• Consider changing to a more memorable password in your account settings</p>
                                </div>
                                
                                <Link to="/" className="link-button" style={{
                                    display: "inline-block",
                                    fontSize: "14px",
                                    padding: "12px 24px"
                                }}>
                                    Go to Login
                                </Link>
                            </div>
                        ) : (
                            <div>
                                <p style={{
                                    marginBottom: "30px", 
                                    lineHeight: "1.6em",
                                    color: "#666",
                                    fontSize: "14px"
                                }}>
                                    The reset link may be invalid, expired, or already used. 
                                    Please request a new password reset if needed.
                                </p>
                                
                                <div>
                                    <Link to="/forgot-password" className="link-button" style={{
                                        display: "inline-block", 
                                        marginRight: "15px",
                                        fontSize: "14px",
                                        padding: "12px 20px"
                                    }}>
                                        Request New Reset
                                    </Link>
                                    <Link to="/" className="link-button" style={{
                                        display: "inline-block",
                                        fontSize: "14px", 
                                        padding: "12px 20px"
                                    }}>
                                        Back to Home
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default ResetPassword;